import { render, staticRenderFns } from "./hole.vue?vue&type=template&id=4b77caee&scoped=true"
import script from "./hole.vue?vue&type=script&lang=js"
export * from "./hole.vue?vue&type=script&lang=js"
import style0 from "./hole.vue?vue&type=style&index=0&id=4b77caee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b77caee",
  null
  
)

export default component.exports